<template>
  <div :class="$style.wrap">
    <van-tabs v-model="show" @click="tabClick">
      <van-tab title="账号密码登录">
        <Accout />
      </van-tab>
      <van-tab title="手机验证码登录">
        <MobilePhone />
      </van-tab>
    </van-tabs>
    <operating :list="operationList" />
  </div>
</template>

<script>
import Accout from "./components/Account";
import MobilePhone from "./components/MobilePhone";
import Operating from "../components/Operating";

export default {
  name: "Login",
  components: { Accout, MobilePhone, Operating },
  data() {
    return {
      show: this.$ls.get("show") || 0
    };
  },
  mounted() {
    this.$ls.clear();
  },
  computed: {
    operationList() {
      let list = [
        { title: "找回密码", type: "findPassword" },
        { title: "找回账号", type: "findAccount" },
        { title: "注册", type: "phoneRegister" }
      ];
      return list;
    }
  },
  watch: {
    $route: {
      handler: function(val) {
        let serverRouter = [
          "/lading",
          "/ask",
          "/back",
          "/lockAccount",
          "/clearLock"
        ];
        if (
          val &&
          val.query.redirect &&
          serverRouter.includes(val.query.redirect)
        ) {
          this._anchor.login.meta.parent = "service/index";
        } else {
          this._anchor.login.meta.parent = "/";
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  methods: {
    tabClick() {
      this.$ls.set("show", this.show);
    }
  }
};
</script>
<style lang="less" module>
.wrap {
  padding-top: 1.49rem;

  :global {
    .van-field__control {
      padding: 0.16rem 0 0.16rem 0.7rem;
    }
    .van-tab {
      font-size: 0.3rem;
      .size(100%, auto);
      line-height: 1.15;
    }
    .van-tabs {
      .flex-center;
      .flex-col;
    }
    .van-tabs__content {
      .size(100%, auto);
    }
    .van-tabs__wrap {
      height: 0.88rem;
      width: 87.5%;
      margin-bottom: 0.76rem;
    }
    .van-tabs__line {
      background-color: @green;
      width: 50% !important;
    }
    .van-tab--active {
      font-weight: bold;
    }
    .van-hairline--top-bottom {
      border-bottom: 0.02rem solid #f3f3f3;
      &:after {
        top: 85%;
        bottom: -38%;
        border-width: 0.03rem 0;
      }
    }
  }
}
</style>
